module.exports = __webpack_public_path__ + "img/red_circle.f33c116a.svg";